// extracted by mini-css-extract-plugin
export default {"contactUs":"ContactUs_contactUs__-cmwO","title":"ContactUs_title__ZgD6c","subtitle":"ContactUs_subtitle__+BfBq"};